import { CreateMemberValidator } from 'validators/ChecklistMembers';
import { FormHandles, Scope } from '@unform/core';
import { Form } from '@unform/web';
import { Input, ToggleInput } from 'components/Shared';
import { FORM_BACK_ACTION } from 'constants/Common';
import { useValidation } from 'hooks';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from 'store';
import { CreateChecklistMemberActions as CreateActions } from 'store/ducks/checklistMembers';
import * as S from './styles';

interface Props {
  onCreate?: () => void;
}

export const MemberCreationForm: React.FC<Props> = ({ onCreate }) => {
  const dispatch: AppDispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors, handleApiErrors } = useValidation();

  const { loading: creatingMember, validationErrors } = useSelector(
    (state: RootState) => state.createChecklistMember
  );

  const onSuccess = useCallback((): void => {
    formRef?.current?.reset();
    onCreate && onCreate();
  }, [onCreate]);

const onSubmit = useCallback(
  async (data: any): Promise<void> => {
    try {
      formRef?.current?.setErrors({});

      const { schema } = new CreateMemberValidator();
      data.user.blockedAt = null;
      const validData = await schema.validate(data, {
        abortEarly: false,
      });

      dispatch(CreateActions.request(validData, onSuccess));
    } catch (error) {
      handleFormErrors(error, formRef);
    }
  },
  [dispatch, handleFormErrors, onSuccess]
);

  useEffect(() => {
    handleApiErrors(validationErrors, formRef);
  }, [handleApiErrors, validationErrors]);

  useEffect(() => {
    return () => {
      dispatch(CreateActions.reset());
    };
  }, [dispatch]);

  return (
    <S.Container>
      <Form ref={formRef} onSubmit={onSubmit}>
        <S.FormRow>
          <Scope path="user">
            <Input name="name" label="Nome completo" />
            <Input name="email" label="Email" />
            <Input name="password" label="Senha" type="password" />
            <ToggleInput name="blockedAt" label="Bloqueado" />
          </Scope>
        </S.FormRow>

        <S.FormActions>
          <S.LinkButton
            mood="light"
            to="/configuracoes/checklist/usuarios"
          >
            {FORM_BACK_ACTION}
          </S.LinkButton>

          <S.Button type="submit">
            {creatingMember ? <S.ActivityIndicator /> : 'Salvar'}
          </S.Button>
        </S.FormActions>
      </Form>
    </S.Container>
  );
};